import { z } from 'zod';

export const docTypeSchema = z.enum([
  'BANK_STATEMENT',
  'RECEIPT',
  'INVOICE',
  'BILL',
  'TAX_DOC',
  'OTHER',
]);

export const docStatusSchema = z.enum([
  'UPLOADED',
  'QUEUED',
  'READING',
  'PROCESSED',
  'NEEDS_INPUT',
  'STORED',
  'FAILED',
]);

export const updateDocumentSchema = z.object({
  docType: docTypeSchema.optional(),
  status: docStatusSchema.optional(),
});

export type UpdateDocumentInput = z.infer<typeof updateDocumentSchema>;
